import { createContext } from 'react'

export const Context = createContext()
export const ModalizeProvider = Context.Provider
